import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row"
};
import { ElSwitch } from 'element-plus';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableTranslatableToggle',
    props: {
        variableType: {},
        translatable: { type: Boolean }
    },
    emits: ["update:translatable"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const translatableProxy = computed({
            get: () => props.translatable,
            set: (value) => {
                emit("update:translatable", value);
            },
        });
        const translatableVariableTypes = new Set(["STRING"]);
        const showTranslatableToggle = computed(() => {
            return translatableVariableTypes.has(props.variableType);
        });
        return (_ctx, _cache) => {
            return (showTranslatableToggle.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_unref(ElSwitch), {
                        "inactive-text": "Translatable",
                        modelValue: translatableProxy.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((translatableProxy).value = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
